import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getDepartamentosPanel = async (searchTerm, searchIDFilter, numPagina, filas) => {
   let queryParams = [];
  
    if (searchTerm) {
      queryParams.push(`depa_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (searchIDFilter) {
      queryParams.push(`pcia_id=${encodeURIComponent(searchIDFilter)}`);
    }
    if (numPagina) {
      queryParams.push(`page=${encodeURIComponent(numPagina)}`);
    }
    if (filas) {
      queryParams.push(`perPage=${encodeURIComponent(filas)}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    return await getData("/departamentos", queryString);
}
export const getDepartamentosLista = async () => {
    const res = await getData('/departamentos');
    return res
}

export const getDepartamentoById = async (id) => {
    const res = await getData(`/departamentos/${id}`)
    return res
}

export const postDepartamento = async (body) => {
    const res = await postData('/departamentos', body)
    return res
}

export const patchDepartamento = async (id, body) => {
    const res = await patchData(`/departamentos/${id}`, body)
    return res
}

export const deleteDepartamento = async (id) => {
    const res = await deleteData(`/departamentos/${id}`)
    return res
}